import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import AppHeader2 from './AppHeader2';
import VendorItems from './VendorItems';
import BottomMenu from './BottomMenu';
import SidebarPanel from './SidebarPanel';

class Vendors extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            LOCATION: this.props.location.pathname,
            LOADING: true, 
            items: [],
            cartEMPTY: 'Y',
            vendor: props.match.params.id,
            VENDORNAME: '',
            CUSTOMER_DET: '',
            page: 1,
            displayLoadMore: ''
        };
    }

    fetchVendorPage(mode,vendor,page) {

        var id = localStorage.getItem('delCIRCLE');

        let customer = '';
        if(localStorage.getItem('userData'))
            customer = localStorage.getItem('userData');
        
        var that = this;
        fetch('https://m.donedelivery.in/api/vendors_api.php?mode='+mode+'&id='+id+'&vendor='+vendor+'&customer='+customer+'&page='+page,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            //console.log(result);
            var ITEMS = result.ITEMS;
            var VENDORNAME = result.VENDORNAME;
            var CUSTOMER_DET = 'Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;

            that.setState({ LOADING:false, items:ITEMS, VENDORNAME:VENDORNAME, CUSTOMER_DET:CUSTOMER_DET, page: result.page, displayLoadMore: result.LOADMORE });
        });
    }

    fetchSecond(mode,vendor,page) {
        var id = localStorage.getItem('delCIRCLE');

        let customer = '';
        if(localStorage.getItem('userData'))
            customer = localStorage.getItem('userData');
       
        var that = this;
        fetch('https://m.donedelivery.in/api/vendors_api.php?mode='+mode+'&id='+id+'&vendor='+vendor+'&customer='+customer+'&page='+page,{
              mode: 'cors',
              credentials: 'same-origin',
              headers: {
                  'Access-Control-Allow-Origin': '*', 
                  Accept: 'application/json', 
                  'Content-Type': 'application/json',
              },
          }).then(function (response) {
            return response.json();
          }).then(function (result) {

            var VENDORNAME = result.VENDORNAME;
            var CUSTOMER_DET = 'Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;
            
            that.setState({ items: that.state.items.concat(result.ITEMS), page: result.page, displayLoadMore: result.LOADMORE});
        });
    }
  
    inCartCallBack = () =>{

        let cartEMPTY = 'Y';
        let cart = localStorage.getItem('cartData');
        if(cart !== null && cart!=='{}')
            cartEMPTY = 'N';

        var that = this;
        that.setState({ cartEMPTY:cartEMPTY });
    }
    
    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
        }
    }

    componentWillReceiveProps(nextProps) {
        window.location.reload();
    }

    componentDidMount() {
        this.fetchVendorPage('VENDOR',this.state.vendor, this.state.page);
    }

    loadMore = () => {
        //this.state.loading = true;
        this.fetchSecond('VENDOR',this.state.vendor, this.state.page);
    };
  
    render() { 
        let AppHeaderClass = 'appHeader bg-dark text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = '/home';
        let AppHeaderTitle = this.state.VENDORNAME;
        let AppHeaderRight = '';
        let AppHeaderRightLink = 'SEARCH';
        let AppHeaderSearch = ''; //this.state.VENDORNAME;

        let props = {
            items: this.state.items,
            inCartCallBack: this.inCartCallBack,
        };

        return (
            <div>
                {this.state.LOADING && <Loader />}
                {this.state.VENDORNAME!='' && <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch} />}
                <div id="appCapsule">
                    <div className="section mt-2 pt-0 pb-2">
                        <div className="row">
                            {this.state.items.length>0 && <VendorItems {...props} />}
                        </div>
                        {this.state.displayLoadMore=='Y' && <p>
                            <button type="button" style={{'height': '31px'}} onClick={() => this.loadMore()} className="btn newshadowed text-dgrey font-size-11 square btn-danger btn-llg btn-block goBack">Load More</button>
                        </p>}
                    </div>
                </div>
                <BottomMenu LOCATION={this.state.LOCATION} />
                {this.state.CUSTOMER_DET && <SidebarPanel CUSTOMER_DET={this.state.CUSTOMER_DET}/>}
            </div>
        );
    }
}
      
export default Vendors;


// WEBPACK FOOTER //
// ./src/components/Vendors.js